var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#808085",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3.5H6.99999V3C6.99999 2.44772 7.4477 2 7.99999 2H12C12.5523 2 13 2.44772 13 3V3.5H14.5C15.6046 3.5 16.5 4.39543 16.5 5.5V16C16.5 17.1046 15.6046 18 14.5 18H5.5C4.39543 18 3.5 17.1046 3.5 16V5.5C3.5 4.39543 4.39543 3.5 5.5 3.5ZM13 5.5V5H14.5C14.7761 5 15 5.22386 15 5.5V16C15 16.2761 14.7761 16.5 14.5 16.5H5.5C5.22386 16.5 5 16.2761 5 16V5.5C5 5.22386 5.22386 5 5.5 5H6.99999V5.5C6.99999 6.05228 7.4477 6.5 7.99999 6.5H12C12.5523 6.5 13 6.05228 13 5.5ZM8.49999 3.5V5H11.5V3.5H8.49999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.8c340d26.svg";
export { ForwardRef as ReactComponent };